import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { getValidations } from '../helpers/validationByFieldType';
import Video from './Video';

// components

class VideoForm extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
  };
  render() {
    const { season } = this.props;
    const { REACT_APP_VIDEO_IS_OPTIONAL } = process.env;
    this.isVideoRequired = REACT_APP_VIDEO_IS_OPTIONAL != "1" ? true : false;
    return (
      <Form>
        <Field
          name="videoUrl"
          season={season}
          component={Video}
          validate={getValidations(this.isVideoRequired)}
        />
      </Form>

    );
  }
}

export default reduxForm({ destroyOnUnmount: false })(VideoForm);



// WEBPACK FOOTER //
// ./src/components/VideoForm.js